// Universal back button — appears in the TopBar and inside deep pages.
// Uses browser history (navigate(-1)) with a smart fallback to a role-specific home
// when there is no meaningful history entry (e.g. first-load).
//
// Import: import BackButton from "@/components/BackButton";
// Usage: <BackButton />  or  <BackButton to="/orders" label="طلباتي" />

import { useNavigate, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function BackButton({ to, label = "رجوع", className = "", variant = "chip" }) {
  const navigate = useNavigate();
  const loc = useLocation();

  const go = () => {
    if (to) { navigate(to); return; }
    // If we have a real history entry, go back. Otherwise fallback to "/".
    if (window.history.length > 1 && loc.key !== "default") {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  if (variant === "icon") {
    return (
      <button onClick={go} aria-label={label}
        className={`w-10 h-10 rounded-xl bg-white/90 hover:bg-white border border-[var(--border)] flex items-center justify-center talabya-shadow-soft ${className}`}
        data-testid="back-button">
        <ArrowRight size={18}/>
      </button>
    );
  }

  // Default "chip" style — icon + Arabic label, subtle background, keyboard-friendly.
  return (
    <button onClick={go} aria-label={label}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-white/70 hover:bg-white border border-[var(--border)] text-sm font-bold text-[var(--text-primary)] transition talabya-shadow-soft ${className}`}
      data-testid="back-button">
      <ArrowRight size={14}/> {label}
    </button>
  );
}
